import { useState } from "react"
import { FormError, InputLista, Loading, MessageModal, Modal, FormLabel, Select } from "../../../common"
import { useForm, useFormErrors } from "../../../hooks"
import { openTempView } from "../../../../utils/openTempView"
import { APPCONFIG } from "../../../../app.config"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, TIPO_TRIBUTO_URLS } from '@laramie/ui';
import { MESSAGE_MODALS } from "../../../../context/custom/MessageModalContext"
import { APIS } from "../../../../config/apis"
import { ServerRequest } from "../../../../utils/apiweb"
import { buildEspecialCreateBody, ESPECIAL_GATE_INIT, isEspecialGateValid } from "../../../../views/EspecialView/utils"
import EspecialGateFields from "../../../../views/EspecialView/components/EspecialGateFields"
import { buildComercioEntityInit } from "../../../../views/ComercioView/utils"
import { buildInmuebleEntityInit } from "../../../../views/InmuebleView/utils"
import { buildCementerioEntityInit } from "../../../../views/CementerioView/utils"
import { buildFondeaderoEntityInit } from "../../../../views/FondeaderoView/utils"
import { buildVehiculoEntityInit, isVehiculoGateValid } from "../../../../views/VehiculoView/utils"
import VehiculoGateFields from "../../../../views/VehiculoView/components/VehiculoGateFields"
import CrearCuentaModal from "../../CrearCuentaModal"
import {TIPS} from "../../../../consts/tips";
import { VALIDATION_MESSAGE } from "../../../../consts/validationMessage"

// Tributos migrados al alta por modal (LAR-1964): se crea acá mismo y se abre la edición
// en pestaña temporal. Los demás siguen el flujo viejo de /x/new hasta que migren.
const CREATE_BY_MODAL = {
    10: { api: APIS.URLS.INMUEBLE, buildEntityInit: buildInmuebleEntityInit, editUrl: (row) => `inmueble/edit/${row.inmueble.id}` },
    11: { api: APIS.URLS.COMERCIO, buildEntityInit: buildComercioEntityInit, editUrl: (row) => `comercio/edit/${row.comercio.id}` },
}

// Tributos con gate (LAR-1965): el alta requiere el tipo, así que en vez de la
// confirmación simple se abre el CrearCuentaModal con el mismo campo que usa la grilla.
const CREATE_BY_GATE_MODAL = {
    13: {
        api: APIS.URLS.CEMENTERIO,
        buildEntityInit: buildCementerioEntityInit,
        lista: 'TipoPrestadorCementerio',
        label: 'Tipo de cuenta',
        applyTipo: (base, idTipo) => ({ ...base, cementerio: { ...base.cementerio, idTipoPrestador: idTipo } }),
        editUrl: (row) => `cementerio/edit/${row.cementerio.id}`,
    },
    14: {
        api: APIS.URLS.FONDEADERO,
        buildEntityInit: buildFondeaderoEntityInit,
        lista: 'TipoFondeadero',
        label: 'Tipo de fondeadero',
        applyTipo: (base, idTipo) => ({ ...base, fondeadero: { ...base.fondeadero, idTipoFondeadero: idTipo } }),
        editUrl: (row) => `fondeadero/edit/${row.fondeadero.id}`,
    },
}

// Vehículo (LAR-1966): gate de 4 campos — reusa los mismos campos y validación que la grilla.
const VEHICULO_TIPO_TRIBUTO = 12
const VEHICULO_CREATE = {
    api: APIS.URLS.VEHICULO,
    editUrl: (row) => `vehiculo/edit/${row.vehiculo.id}`,
}
const VEHICULO_GATE_INIT = { idIncisoVehiculo: 0, vehiculoMenor: false, idTipoVehiculo: 0, anioModelo: '', dominio: '' }

const ESPECIAL_TIPO_TRIBUTO = 15
const ESPECIAL_CREATE = {
    api: APIS.URLS.ESPECIAL,
    editUrl: (row) => `cuenta-especial/edit/${row.especial.id}`,
}

export const SelectTipoTributoModal = ({ show, close }) => {
    const [value, setValue] = useState(0)
    const [showConfirm, setShowConfirm] = useState(false)
    const [gateModal, setGateModal] = useState({ show: false, idTipo: 0 })
    const [vehiculoGate, setVehiculoGate] = useState({ show: false, ...VEHICULO_GATE_INIT })
    const [showEspecialGate, setShowEspecialGate] = useState(false)
    const [especialGate, , especialGateReset, especialGateSet] = useForm(ESPECIAL_GATE_INIT)
    const [loading, setLoading] = useState(false)

    const { errorOf, validate, reset } = useFormErrors(getErrors)

    const onClose = () => {
        reset()
        close()
    }

    function getErrors() {
        const errors = {}

        if (!CREATE_BY_MODAL[value] && !CREATE_BY_GATE_MODAL[value] && value !== VEHICULO_TIPO_TRIBUTO && value !== ESPECIAL_TIPO_TRIBUTO && !TIPO_TRIBUTO_URLS[value]) {
            errors.idTipoTributo = VALIDATION_MESSAGE.REQUIRED_OPTION
        }

        return errors
    }

    const onAccept = () => {
        if (!validate()) return

        if (CREATE_BY_MODAL[value]) {
            setShowConfirm(true)
        }
        else if (CREATE_BY_GATE_MODAL[value]) {
            setGateModal({ show: true, idTipo: 0 })
        }
        else if (value === VEHICULO_TIPO_TRIBUTO) {
            setVehiculoGate({ show: true, ...VEHICULO_GATE_INIT })
        }
        else if (value === ESPECIAL_TIPO_TRIBUTO) {
            especialGateReset()
            setShowEspecialGate(true)
        }
        else if (TIPO_TRIBUTO_URLS[value]) {
            onClose()
            openTempView(`${APPCONFIG.SITE.WEBAPP}${TIPO_TRIBUTO_URLS[value]}/new`)
        }
    }

    const CreateCuenta = (config, dataBody) => {
        setLoading(true)

        const callbackSuccess = (response) => {
            response.json()
                .then((row) => {
                    setLoading(false)
                    onClose()
                    openTempView(`${APPCONFIG.SITE.WEBAPP}${config.editUrl(row)}`)
                })
                .catch((error) => {
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando respuesta: ' + error)
                    setLoading(false)
                })
        }
        const callbackNoSuccess = (response) => {
            response.json()
                .then((error) => {
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error.message)
                    setLoading(false)
                })
                .catch((error) => {
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando respuesta: ' + error)
                    setLoading(false)
                })
        }
        const callbackError = (error) => {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando solicitud: ' + error.message)
            setLoading(false)
        }

        ServerRequest(
            REQUEST_METHOD.POST, null, true,
            config.api, null,
            dataBody,
            callbackSuccess, callbackNoSuccess, callbackError
        )
    }

    const confirmCreate = () => {
        const config = CREATE_BY_MODAL[value]
        setShowConfirm(false)
        CreateCuenta(config, config.buildEntityInit())
    }

    const confirmCreateConTipo = () => {
        const config = CREATE_BY_GATE_MODAL[value]
        setGateModal(prevState => ({ ...prevState, show: false }))
        CreateCuenta(config, config.applyTipo(config.buildEntityInit(), gateModal.idTipo))
    }

    const confirmCreateVehiculo = () => {
        setVehiculoGate(prevState => ({ ...prevState, show: false }))
        const base = buildVehiculoEntityInit()
        CreateCuenta(VEHICULO_CREATE, {
            ...base,
            vehiculo: {
                ...base.vehiculo,
                idIncisoVehiculo: vehiculoGate.idIncisoVehiculo,
                idTipoVehiculo: vehiculoGate.idTipoVehiculo,
                anioModelo: vehiculoGate.anioModelo,
                dominio: vehiculoGate.dominio
            },
            // el número de cuenta de Vehículo se deriva del dominio
            cuenta: { ...base.cuenta, numeroCuenta: vehiculoGate.dominio }
        })
    }

    const confirmCreateEspecial = () => {
        setShowEspecialGate(false)
        CreateCuenta(ESPECIAL_CREATE, buildEspecialCreateBody(especialGate))
    }

    const dismissEspecialGate = () => {
        setShowEspecialGate(false)
        especialGateReset()
    }

    return (
        <>
            <Modal
                onEscape={onClose}
                show={show}
                title='Selección de tipo de tributo'
                tipName={TIPS.NAME.MODALS.SELECCION_TIPO_TRIBUTO_MODAL}
                body={(
                    <div className='row form-basic'>
                        <div className="col-12">
                            <FormLabel htmlFor="idTipoTributo" required>Tipo de tributo</FormLabel>
                            <InputLista
                                name="idTipoTributo"
                                placeholder=""
                                className={`form-control ${errorOf('idTipoTributo') ? 'is-invalid' : ''}`}
                                value={value}
                                onChange={({ target }) => setValue(target.value)}
                                lista="TipoTributo"
                            />
                            <FormError message={errorOf('idTipoTributo')} />
                        </div>
                    </div>
                )}
                footer={<>
                    <button className="btn btn-outline-primary" data-dismiss="modal" onClick={onClose}>Cancelar</button>
                    <button className="btn btn-primary" data-dismiss="modal" onClick={onAccept}>Aceptar</button>
                </>}
            />

            {showConfirm && (
                <MessageModal
                    title={MESSAGE_MODALS.CREAR.title}
                    message={MESSAGE_MODALS.CREAR.message}
                    confirmLabel={MESSAGE_MODALS.CREAR.confirmLabel}
                    onDismiss={() => setShowConfirm(false)}
                    onConfirm={confirmCreate}
                />
            )}

            {gateModal.show && (
                <CrearCuentaModal
                    canConfirm={gateModal.idTipo > 0}
                    onConfirm={confirmCreateConTipo}
                    onDismiss={() => setGateModal({ show: false, idTipo: 0 })}
                >
                    <div className="mb-3">
                        <FormLabel htmlFor="idTipo" required>{CREATE_BY_GATE_MODAL[value].label}</FormLabel>
                        <Select
                            name="idTipo"
                            className="form-control"
                            lista={CREATE_BY_GATE_MODAL[value].lista}
                            value={gateModal.idTipo}
                            onChange={({ target }) => setGateModal(prevState => ({ ...prevState, idTipo: target.value }))}
                        />
                    </div>
                </CrearCuentaModal>
            )}

            {vehiculoGate.show && (
                <CrearCuentaModal
                    canConfirm={isVehiculoGateValid(vehiculoGate)}
                    onConfirm={confirmCreateVehiculo}
                    onDismiss={() => setVehiculoGate({ show: false, ...VEHICULO_GATE_INIT })}
                >
                    <VehiculoGateFields
                        gate={vehiculoGate}
                        onChange={(patch) => setVehiculoGate(prevState => ({ ...prevState, ...patch }))}
                    />
                </CrearCuentaModal>
            )}

            {showEspecialGate && (
                <CrearCuentaModal
                    canConfirm={isEspecialGateValid(especialGate)}
                    onConfirm={confirmCreateEspecial}
                    onDismiss={dismissEspecialGate}
                >
                    <EspecialGateFields
                        gate={especialGate}
                        onChange={(patch) => especialGateSet({ ...especialGate, ...patch })}
                    />
                </CrearCuentaModal>
            )}

            <Loading visible={loading} />
        </>
    )
}
